import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { ITimelineProps } from '../timeline';

function timelineAdapter(data: any): ITimelineProps {
    return {
        image: data.imagenPrincipal ? data.imagenPrincipal.file.url : '',
        title: data.tituloGeneral ? data.tituloGeneral : '',
        desc: data.descripcion ? documentToReactComponents(JSON.parse(data.descripcion.raw)) : '',
        items:
            data?.referenciaPlantillaContenido?.map((item: any) => ({
                image: item.imagenPrincipal ? item.imagenPrincipal[0].file.url : '',
                title: item.tituloBanner ? item.tituloBanner : '',
                desc: item.descripcion ? documentToReactComponents(JSON.parse(item.descripcion.raw)) : '',
                text: item.tipoTitulo ? item.tipoTitulo : '',
                year: item.tituloDescripcion ? item.tituloDescripcion : ''
            })) ?? [],
    };
}

export default timelineAdapter;
